import React, { useState } from 'react';
import { Alert, AlertTitle } from '@mui/material';

/**
 * Aviso compacto e dispensavel (com icone de fechar) exibido no topo de um Painel
 * de Eficiencia quando o banco de dados necessario ainda nao esta configurado para
 * o municipio ativo. Os paineis/graficos continuam visiveis (vazios) por baixo.
 *
 * Gerencia o proprio estado de "fechado": some ao clicar no X e, como fica montado
 * enquanto o painel seguir nao configurado, nao reaparece nos auto-refreshes do
 * mesmo contexto (reaparece apenas ao voltar para um municipio/unidade nao configurado).
 */
interface Props {
  mensagem?: string;
}

const PainelNaoConfigurado: React.FC<Props> = ({
  mensagem = 'O banco de dados deste painel ainda nao esta configurado para este municipio. Os dados podem aparecer vazios.',
}) => {
  const [aberto, setAberto] = useState(true);
  if (!aberto) return null;
  return (
    <Alert severity="info" onClose={() => setAberto(false)} sx={{ mb: 2 }}>
      <AlertTitle sx={{ mb: 0 }}>Painel indisponivel</AlertTitle>
      {mensagem}
    </Alert>
  );
};

export default PainelNaoConfigurado;
